<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="false"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-typed-value-list-complex-base
            [indeterminateMsg]="indeterminateMsg"
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [types]="types"
            [typePlaceholderMsg]="typePlaceholderMsg"
            [valueLabel]="valueLabel"
            [valuePlaceholderMsg]="valuePlaceholderMsg"
            [id]="controlId"
            [isDisabled]="control.disabled"
            [autocompleteFcts]="autocompleteFcts"
        ></sh-form-typed-value-list-complex-base>
    </ng-template>
    <ng-template #simple>
        <sh-form-typed-value-list-base
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [types]="types"
            [typePlaceholderMsg]="typePlaceholderMsg"
            [valueLabel]="valueLabel"
            [valuePlaceholderMsg]="valuePlaceholderMsg"
            [id]="controlId"
            [isDisabled]="control.disabled"
            [autocompleteFcts]="autocompleteFcts"
        ></sh-form-typed-value-list-base>
    </ng-template>
</sh-form-group>
